export default "__VITE_ASSET__Ritk0vS7__"